<template>
  
<path d="M4 15L5 10L1 8.5L8 1L7 6L11 7.5L4 15Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</template>